// src/components/AdminDashboard/TabNavigation.js
import React from "react";

const TabNavigation = ({ activeTab, setActiveTab }) => (
  <div className="border-b border-gray-200 mb-6">
    <nav className="-mb-px flex space-x-8">
      {[
        { key: "users", label: "User Management" },
        { key: "badges", label: "Badge Management" },
        { key: "feedback", label: "Feedback Management" },
        { key: "notifications", label: "Notifications" },
      ].map((tab) => (
        <button
          key={tab.key}
          onClick={() => setActiveTab(tab.key)}
          className={`py-2 px-1 border-b-2 font-medium text-sm ${
            activeTab === tab.key
              ? "border-blue-500 text-blue-600"
              : "border-transparent text-gray-500 hover:text-gray-700"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  </div>
);

export default TabNavigation;
